/** Neutral first-party path (avoids /api/op + op1.js blocklists). */
export const OPENPANEL_PROXY_PATH = '/api/fac/collect' as const;

export const OPENPANEL_PROXY_SCRIPT_URL =
	`${OPENPANEL_PROXY_PATH}/client.js` as const;

export const openpanelClientId =
	process.env.NEXT_PUBLIC_OPENPANEL_CLIENT_ID?.trim() ?? '';

/** Self-hosted OpenPanel API (no `/api` suffix on the opapi host). */
export const openpanelApiUrl = process.env.OPENPANEL_API_URL?.trim() ?? '';

export const isOpenPanelEnabled = Boolean(openpanelClientId);
